import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { PhoneCreate } from '@app/models/phone.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-phone-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class PhoneFormComponent {
  initialValue = input<PhoneCreate>();
  formChange = output<PhoneCreate>();
  formValid = output<boolean>();

  phoneForm = new FormGroup<AutoForm<PhoneCreate>>({
    name: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    provider_id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true}),
    current_device_id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true}),
    current_user_id: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    //current_sequence_id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true}),
    unique_id: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    model: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    os: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    os_version: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    mfg: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.phoneForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.phoneForm.valid);
    this.formChange.emit(<PhoneCreate>this.phoneForm.value);
  }
}